import { ContentProvider } from "@/models/contentprovider";

export interface IANumberGroup {
    uuid?: string | null;
    groupName?: string | null;
    createDate?: string | null;
    updateDate?: string | null;
    contentProvider?: ContentProvider | null;
    members?: any | null;
}

export class ANumberGroup {

    public uuid!: string | null;
    public groupName!: string | null;
    public createDate!: string | null;
    public updateDate!: string | null;
    public contentProvider!: ContentProvider | null;
    public members!: any | null;

    constructor(aNumberGroup: IANumberGroup) {
        if (!aNumberGroup) {
            throw new Error("Cannot construct ANumberGroup from falsey IANumberGroup");
        }

        this.uuid = aNumberGroup.uuid || null
        this.groupName = aNumberGroup.groupName || null
        this.createDate = aNumberGroup.createDate || null
        this.updateDate = aNumberGroup.updateDate || null
        this.contentProvider = aNumberGroup.contentProvider || ContentProvider.empty()
        this.members = aNumberGroup.members || []

    }

    public static empty(): ANumberGroup {
        return new ANumberGroup({});
    }

    public toNewANumberGroupDto(): IANumberGroup {
        return {
            groupName: this.groupName
        };
    }

    public toUpdateANumberGroupDto(): IANumberGroup {
        // these wind up being the same implementation but are semantically different
        const result = this.toNewANumberGroupDto();
        result.uuid = this.uuid;
        return result;
    }

    public get groupNameValidationRules(): Array<(value: string) => boolean | string> {
        return [
            (x) => {
                if (!x) {
                    return "Group Name is required";
                }
                else if (x.length < 4)
                {
                    return "The group name must be at least 4 characters.";
                }
                else if (x.length > 256)
                {
                    return "This group name can have a max of 256 characters.";
                }
                return true;
            },
        ];
    }

    public toUpdateANumberGroupMembersDto(): IANumberGroup {
        return this.members;
    }
}
